module.exports = __webpack_public_path__ + "static/media/laf_red.0fdb745c.png";